import React from 'react';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as Constants from '../../../common/constants';
export const PrimaryButton = (props) => {
    const { children, type = 'button', size = 'medium', width, fullWidth, loading = false, disabled = false, inverted = false, onClick, } = props;
    if (inverted) {
        return (React.createElement(SButtonInverted, { type: type, variant: "contained", size: size, fullWidth: fullWidth, disabled: loading || disabled, onClick: onClick, style: { width } }, loading ? React.createElement(CircularProgress, { size: 30 }) : children));
    }
    else {
        return (React.createElement(SButton, { type: type, variant: "contained", size: size, fullWidth: fullWidth, disabled: loading || disabled, onClick: onClick, style: { width } }, loading ? React.createElement(CircularProgress, { size: 30 }) : children));
    }
};
const SButton = styled(Button) `
  &&& {
    background-color: ${Constants.COLOR.ORANGE700};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    color: #fff;
    font-weight: bold;
  }
`;
const SButtonInverted = styled(Button) `
  &&& {
    background-color: #fff;
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    color: ${Constants.COLOR.ORANGE700};
    font-weight: bold;
    border: 1px solid ${Constants.COLOR.ORANGE700};
  }
`;
